import Nullstack from 'nullstack';
export default function IconMoodCrazyHappy({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mood-crazy-happy",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "8.5",
    x2: "10",
    y2: "11.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 11.5l3 -3"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "8.5",
    x2: "17",
    y2: "11.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 11.5l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), " ");
}